import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/offers/useStewardshipFilter';
import REQUIRED_FIELDS from '@/pages/offers/REQUIRED_FIELDS';
import { useConnect } from '@hooks/@lore/query-connect';
import _ from 'lodash';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          $and: _.remove([
          ...REQUIRED_FIELDS.$and,
          stewardshipFilter ? {
            $or: stewardshipFilter
          } : undefined]
          ),
          $or: [
          {
            specificDate: 'Yes',
            date: {
              // A resource is still active through the entirety of its date,
              // so "expired" ($lt, not $lte) only starts the day after - this
              // needs to stay the exact complement of the $gte used to decide
              // a resource is still active (see REQUIRED_FIELDS_PUBLIC).
              $lt: moment(timestamp).toISOString()
              // $gte: moment(timestamp).subtract(4, 'weeks').toISOString()
            }
          },
          {
            specificDate: 'No',
            endDate: {
              $lt: moment(timestamp).toISOString()
              // $gte: moment(timestamp).subtract(4, 'weeks').toISOString()
            }
          }],

          cancelled: false,
          completed: false,
          ...extra
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}